export const normalizedStringTokens = (inputString: string, separator: string = ' ') => inputString
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .split(separator);
